<template>
  <v-container fluid>
    <h3 class="mb-5">Dokumento duomenys</h3>
    <el-overlay-loading :loading="pageloading" />
    <div class="dataContainer">
      <v-row>
        <template v-if="isPrasymasPirmenybe && isPrasymasIregistravimas">
          <v-col cols="12" md="12">
            <el-radio-group
              required
              inline
              class="mb-2"
              :readonly="isReadonlyForm"
              :items="pirmenybesSalyga"
              v-model="formData.pra_yra_pirmenybes_salyga"
              @click.native="checkData()"
            />
          </v-col>
          <v-col cols="12" md="12">
            <el-textarea
              v-if="showPirmenybeSalyga"
              label="Pirmenybės teisės pirkti atsisakymo sąlygos"
              :tooltip="
                `${ntrTooltipPrefix} Duomenys. Pirmenybės teisės pirkti atsisakymo sąlygos`
              "
              :counter="2000"
              need
              :readonly="isReadonlyForm"
              v-model="formData.pra_pirmenybes_salyga"
              @blur="checkData()"
            />
          </v-col>
        </template>
        <v-col cols="12" md="6">
          <el-text-field
            need
            label="Dokumento numeris"
            :tooltip="`${ntrTooltipPrefix} Duomenys. Dokumento numeris`"
            :counter="50"
            :readonly="isReadonlyForm"
            v-model="formData.pra_dokumento_numeris"
            @blur="checkData()"
            autofocus
          />
        </v-col>
        <v-col cols="12" md="6">
          <el-text-field
            need
            label="Dokumento vieta"
            :tooltip="`${ntrTooltipPrefix} Duomenys. Dokumento vieta`"
            :counter="50"
            :readonly="isReadonlyForm"
            v-model="formData.pra_dokumento_vieta"
            @blur="checkData()"
          />
        </v-col>
        <v-col cols="12" md="6">
          <el-date-picker
            need
            label="Dokumento data"
            :tooltip="`${ntrTooltipPrefix} Duomenys. Dokumento data`"
            :readonly="isReadonlyForm"
            v-model="formData.pra_dokumento_data"
            @blur="checkData()"
          />
        </v-col>
        <v-col cols="12" md="6" v-if="showPagrindas">
          <el-autocomplete
            :items="pagrindasList"
            itemvalue="value"
            itemtext="text"
            returnObject
            label="Juridinio fakto išregistravimo pagrindas"
            :tooltip="
              `${ntrTooltipPrefix} Duomenys. Juridinio fakto išregistravimo pagrindas`
            "
            need
            :readonly="isReadonlyForm"
            v-model="pagrindasItem"
            @change="checkData()"
          />
        </v-col>

        <template>
          <v-col cols="12" md="12" v-if="showPapildomasCol">
            <el-button
              v-if="!showPapildomasIrasas && !isReadonlyForm"
              class="mb-5"
              primary
              small
              @click.native="clickPapildomas()"
              >Pridėti papildomą įrašą</el-button
            >
            <el-textarea
              v-if="showPapildomasIrasas"
              label="Papildomas įrašas"
              :tooltip="`${ntrTooltipPrefix} Duomenys. Papildomas įrašas`"
              :counter="4000"
              :readonly="isReadonlyForm"
              v-model="formData.pra_papildomas_irasas"
              @blur="checkData()"
            />
          </v-col>
        </template>
      </v-row>
    </div>

    <v-footer class="form-footer" v-if="!isReadonly">
      <v-spacer></v-spacer>
      <el-button
        primary
        @click.native="checkErrorsClick()"
        :loading="loadingTikrinti"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import tooltipNtr from '@/mixins/tooltipNtr'
import unsavedData from '@/mixins/unsavedData'
import checkErrors from '@/mixins/checkErrors'

export default {
  name: 'RegPrasymasDuomenys',
  props: {
    readonlyForm: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  mixins: [userRole, busena, tooltipNtr, unsavedData, checkErrors],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      formData: {},
      forcePapildomasIrasas: false,
      pagrindasList: [],
      pagrindasItem: null,
    }
  },
  computed: {
    ...mapGetters(['prasymasID', 'prasymasSistema', 'pagrindasKodas']),
    isSistemaSavitarna() {
      return this.prasymasSistema === 'savitarna'
    },
    isReadonly() {
      return this.readonly
    },
    isReadonlyForm() {
      return this.readonlyForm
    },
    showPapildomasCol() {
      return (
        !this.pageloading &&
        (this.isPrasymasSeima ||
          this.isPrasymasBendra ||
          this.isPrasymasPirmenybe)
      )
    },
    showPapildomasIrasas() {
      return (
        (this.formData && this.formData.pra_papildomas_irasas) ||
        this.forcePapildomasIrasas
      )
    },
    showPagrindas() {
      return this.isPrasymasSeima && this.isPrasymasIsregistravimas
    },
    showPirmenybeSalyga() {
      return this.formData.pra_yra_pirmenybes_salyga === 1
    },
    pirmenybesSalyga() {
      return [
        {
          label: 'Atsisakymas sąlyginis',
          tooltip: `${this.ntrTooltipPrefix} Duomenys. Atsisakymas sąlyginis`,
          value: 1,
        },
        {
          label: 'Atsisakymas besąlyginis',
          tooltip: `${this.ntrTooltipPrefix} Duomenys. Atsisakymas besąlyginis`,
          value: 2,
        },
      ]
    },
  },
  watch: {
    pagrindasItem(item) {
      if (this.formData.pra_pagrindas_kla_id != item.value) {
        this.formData.pra_pagrindas_kla_id = item.value
        this.formData.pagrindas_kodas = item.kla_kodas
        this.$store.dispatch('pagrindasKodas', item.kla_kodas)
        this.saveData()
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.loadingTikrinti = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/duomenys`)
        .then(res => {
          this.formData = res.data.duomenys
          this.pagrindasList = res.data.pagrindas
          this.setPagrindasItem()
          this.forcePapildomasIrasas = !!this.formData.pra_papildomas_irasas
          if (
            this.isReadonlyForm &&
            this.formData.pra_yra_pirmenybes_salyga === 0
          ) {
            this.formData.pra_yra_pirmenybes_salyga = 2
          }
          this.$nextTick(() => {
            this.initialForm()
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.loadingTikrinti = false
          this.pageloading = false
        })
    },
    saveData(toRoute, afterSave) {
      if (toRoute) {
        this.goToRoute()
        return
      }
      if (this.isReadonlyForm) {
        return
      }
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let data = this.formData
          data.pra_id = this.prasymasID

          this.$axios
            .post(`ntrpaslaugos/prasymas/${this.prasymasID}/duomenys`, data)
            .then(res => {
              this.updateErrors()
              this.initialForm()
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    checkErrorsClick() {
      this.loadingTikrinti = true
      this.checkNtrErrors()
    },
    clickPapildomas() {
      this.forcePapildomasIrasas = true
    },
    setPagrindasItem() {
      this.pagrindasList.forEach(item => {
        if (item.value == this.formData.pra_pagrindas_kla_id) {
          this.pagrindasItem = item
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 900px;
}
</style>
